import React from 'react'
import CommoditiesMain from './CommoditiesMain'

const Commodities = () => {
  return (<>
    <CommoditiesMain />
  </>)
}
export default Commodities